export const getKeysFromObject = <T extends object>(object: T) => {
  return Object.keys(object) as (keyof typeof object)[];
};

export const getItemsFromObject = <T extends object>(object: T) => {
  return getKeysFromObject(object).map((key) => object[key]);
};
